<template>
  <main class="coming-soon-page">
    <section class="coming-soon-panel">
      <div class="coming-soon-icon">
        <vue-feather :type="icon" size="32" />
      </div>
      <p class="eyebrow">{{ t('comingSoon') }}</p>
      <h1>{{ title }}</h1>
      <p class="description">{{ description }}</p>
      <router-link to="/" class="home-link">
        <vue-feather type="arrow-left" size="18" />
        {{ t('backHome') }}
      </router-link>
    </section>
  </main>
</template>

<script>
export default {
  name: 'ComingSoon',
  inject: {
    languageRef: { from: 'currentLanguage', default: 'EN' }
  },
  computed: {
    currentLanguage() {
      return this.languageRef?.value || this.languageRef || 'EN';
    },
    title() {
      if (this.currentLanguage === 'TA') {
        return this.$route.meta?.titleTA || this.$route.meta?.title || this.t('comingSoon');
      }
      return this.$route.meta?.title || this.t('comingSoon');
    },
    description() {
      if (this.currentLanguage === 'TA') {
        return this.$route.meta?.descriptionTA || this.$route.meta?.description || this.t('defaultDescription');
      }
      return this.$route.meta?.description || this.t('defaultDescription');
    },
    icon() {
      return this.$route.meta?.icon || 'clock';
    }
  },
  methods: {
    t(key) {
      const translations = {
        comingSoon: {
          EN: 'Coming soon',
          TA: 'விரைவில் வருகிறது'
        },
        defaultDescription: {
          EN: 'This feature is being prepared.',
          TA: 'இந்த வசதி தற்போது தயாராகிறது.'
        },
        backHome: {
          EN: 'Back to home',
          TA: 'முகப்புக்குச் செல்ல'
        }
      };

      return translations[key]?.[this.currentLanguage] || translations[key]?.EN || key;
    }
  }
}
</script>

<style scoped>
.coming-soon-page {
  min-height: calc(100vh - 56px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  background: var(--bg-primary, #f8f8f8);
}

.coming-soon-panel {
  width: min(560px, 100%);
  text-align: center;
  padding: 48px 32px;
  border: 1px solid var(--border-color, #e7e7e7);
  border-radius: 12px;
  background: var(--bg-secondary, #fff);
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.06);
}

.coming-soon-icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: var(--primary-color, #ff4444);
  background: rgba(255, 68, 68, 0.1);
}

.eyebrow {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--primary-color, #ff4444);
}

h1 {
  margin: 0;
  font-size: 32px;
  line-height: 1.2;
  color: var(--text-primary, #333);
}

.description {
  margin: 14px auto 28px;
  max-width: 420px;
  color: var(--text-secondary, #777);
  line-height: 1.6;
}

.home-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 18px;
  border-radius: 999px;
  color: #fff;
  background: var(--primary-color, #ff4444);
  text-decoration: none;
  font-weight: 700;
}

@media (max-width: 640px) {
  .coming-soon-page {
    padding: 32px 16px;
  }

  .coming-soon-panel {
    padding: 36px 22px;
  }

  h1 {
    font-size: 26px;
  }
}
</style>
